import { setDocumentTitle } from "@/lib/documentTitle";
// src/components/admin/qtl - referential/issuers/main.tsx

import { useEffect } from "react";
import { IssuersCard } from "./card";
import { IssuersNew } from "./new";
import { Route, Routes } from "react-router-dom";

import { IssuersTable } from "./table";

export default function Issuer() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Émetteurs");
  }, []);

  return (
    <Routes>
      <Route index element={<IssuersTable />} />
      <Route path="/new" element={<IssuersNew />} />
      <Route path=":id" element={<IssuersCard />} />
    </Routes>
  );
}
